import { Wording } from '@/types';

export const YOGA_WORDING_CZ: Wording = {
  components_header_media_content: 'Tréninky',
  components_header_media_1: '',
  components_header_text1: 'Recepty',
  components_header_text2: 'Blog',
  components_header_members: 'Členové',
  hero_text: 'Udržujte své tělo pružné a silné',
  hero_button_text: 'Začněte svou jógovou cestu',
  components_ressources_section_title: 'ZDROJE',
  components_ressources_subheader_text: 'Všechny zdroje, které potřebujete pro harmonický životní styl',
  components_ressources_span_text: 'Odhalte tajemství wellness: Ponořte se do sbírky jógových pozic, vědomých meditací a zdravých receptů, které vám pomohou najít rovnováhu v každém aspektu vašeho života.',
  components_ressources_card_1_title: 'Tipy pro jógu',
  components_ressources_card_1_text: 'Praktické rady pro prohloubení praxe a zdokonalení pozic.',
  components_ressources_card_2_title: 'Strava',
  components_ressources_card_2_text: 'Chytré tipy na výživu pro zdravější a silnější já.',
  components_ressources_link: 'Sledujte videa',
  components_notes_and_google_title_1: 'Cvičení jógy',
  components_notes_and_google_title_2: 'Pravidelná rutina',
  components_notes_and_google_title_3: 'Dodržování diety',
  components_review_google_text: 'Recenze na Googlu',
  media_content_section_title: 'CVIČENÍ',
  media_content_section_subheader_text: 'Naše videa',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Další videa',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Články a novinky',
  text2_section_button_more: 'Další články',
  components_text1_section_title: 'RECEPTY',
  components_text1_subheader_text: 'Vyživte své tělo i mysl',
  components_text1_span_text: 'Zdravé recepty na podporu vaší jógové praxe a zlepšení vaší pohody.',
  components_text1_card_1_title: 'Energizující snídaně',
  components_text1_card_1_text: 'Probuďte se s energickými a energeticky úspornými jídly.',
  components_text1_card_3_title: 'Obědy plné energie',
  components_text1_card_3_text: 'Objevte lahodné a praktické recepty na obědy určené pro váš aktivní životní styl. Od barevných salátů až po wrapy plné bílkovin, tyto recepty vám dodají energii a soustředění.',
  components_text1_card_2_title: 'Večeře pro zotavení',
  components_text1_card_2_text: 'Pro uspokojivý konec dne prozkoumejte různé druhy libových bílkovin, celozrnných výrobků a pestré zeleniny.',
  components_text1_link: 'Zobrazit všechny recepty',
  components_footer_text: 'Najděte rovnováhu, zhluboka dýchejte: Vaše jóga, vaše cesta.',
  components_footer_info: 'Informace',
  components_footer_registration_number: 'Evidenční číslo',
  components_footer_legal: 'Právní',
  components_footer_terms: 'Obchodní podmínky',
  components_footer_privacy: 'Zásady ochrany osobních údajů',
  button_load_more: 'Načíst více',
  page_media_1_content_hero_text: 'Cvičení jógy',
  page_text1_hero_text: 'Recepty',
  page_text1_section_title: 'Výživa',
  page_text1_subheader_text: 'Recepty',
  page_text2_hero_text: 'Náš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Články a novinky',
  enter_email_title: 'Pro pokračování zadejte prosím svůj e-mail',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Zadejte',
  components_login_success_text: 'Přihlášení úspěšné!',
  components_card_link_media_content: 'Sledujte nyní',
  components_card_link_text1_content: 'Zobrazit recept',
  components_card_link_text2_content: 'Zobrazit článek',
  france: 'Francie',
  cyprus: 'Kypr',
};